import styled from "styled-components";
import { mobile } from "../../../../../ui/_themes/constants";

export const MenuNav = styled.div`
  display: inherit;
  position: relative;

  @media (orientation: landscape) {
    flex: 0 0 ${mobile.landscape.sidePanel.width};
    flex-direction: column;
  }

  @media (orientation: portrait) {
    flex: 0 0 ${mobile.portrait.middlePanel.navigation.height};
  }
`;
